export const ARTICLES = [
  {
    id: 'HLKB-0001',
    slug: 'bbs-dawn-1996',
    title: '1996年那批没有名字的聊天室，藏着中文互联网最早的黑话',
    excerpt:
      '那时候没人管它叫社区，也没人在意谁先注册。几十个只有编号的聊天室，却悄悄长出了第一批属于中文网络的暗语。',
    categoryId: 'forum',
    categoryName: '早期论坛',
    tags: ['早期论坛', '聊天室', '黑话'],
    author: '老磁带',
    date: '2025-08-14',
    readTime: 9,
    views: '28,410',
    heat: '极高',
    status: '已归档 · 材料完整',
    cover:
      'https://readdy.ai/api/search-image?query=dim%20room%20lit%20only%20by%20an%20old%20crt%20computer%20screen%20showing%20a%20blinking%20text%20chat%20interface%2C%20warm%20amber%20phosphor%20glow%2C%20dust%20in%20the%20air%2C%20stacks%20of%20floppy%20disks%2C%20nostalgic%20archival%20mood%2C%20brown%20and%20gold%20tones&width=900&height=620&seq=hlkb-art-01&orientation=landscape',
    body: [
      {
        type: 'lead',
        text: '在搜索引擎还没占领入口的年代，人们是靠一串数字找到彼此的。没有头像，没有昵称，只有「房间3」「房间17」这样冷冰冰的编号，和一句「有人在吗」。',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'heading',
        text: '一个房间，就是一座城',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'paragraph',
        text: '最早的一批聊天室连名字都懒得取。管理员把服务器开起来，房间按开服顺序编号，进去的人默认显示一串随机字符。奇怪的是，正是这种匿名感，让所有人说话都格外直接。有人在里面连载小说，有人整夜用「/me」描述自己泡面的过程，也有人只是每天准点出现，说一句「来了」就再也没有下文。',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'list',
        text: '那一时期流传下来的说法，如今看来几乎是一套完整的地方方言：',
        items: [
          '「886」——不是拜拜了的意思，最早只是输入法打不出完整句子时的省事写法',
          '「青蛙」「恐龙」——见面之前先互相通报的形容，带着分寸感十足的戏谑',
          '「灌水」——从天而降，形容那些没有信息量却源源不断的发言',
          '「踩一脚」——在别人的帖子里留下存在感的最短动作',
        ],
        image: '',
        caption: '',
      },
      {
        type: 'image',
        image:
          'https://readdy.ai/api/search-image?query=close%20up%20of%20yellowed%20printed%20chat%20logs%20and%20handwritten%20notes%20about%20internet%20slang%2C%20pinned%20on%20a%20dark%20corkboard%2C%20warm%20desk%20lamp%20light%2C%20archival%20research%20mood%2C%20deep%20brown%20and%20amber%20palette&width=1000&height=620&seq=hlkb-art-01-inline&orientation=landscape',
        caption: '早期聊天记录多靠手动抄写与打印保存，图中为档案员重排的复原稿。',
      },
      {
        type: 'heading',
        text: '黑话是怎么长出来的',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'paragraph',
        text: '语言学家会说这是「群体身份标识」，但对当时的人来说，理由朴素得多：打字慢。拨号上网按分钟计费，键盘又难按，于是能省的字一律省掉。省得多了，固定搭配就出现了；用得久了，外人就听不懂了。黑话不是被设计出来的，它是被网速和话费一起逼出来的。',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'quote',
        text: '我们那会儿不是想创造什么文化，纯粹是话费太贵，能少打一个字是一个字。',
        items: [],
        image: '',
        caption: '—— 一位1997年开始上网的早期用户，档案员访谈记录',
      },
      {
        type: 'paragraph',
        text: '后来的论坛、博客、短视频各领风骚，但那套「把话说短」的本能一直留了下来。今天我们在弹幕里打的那些缩写，本质上是同一条路径的延长线，只是当年的催化剂是话费单，现在是视频倍速。',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'note',
        text: '档案状态：本文依据 4 份用户存档聊天记录、2 份同期电子刊物与 1 段访谈音频整理，时间线已交叉核对。房间编号为保护提供者隐私，统一做了模糊处理。',
        items: [],
        image: '',
        caption: '',
      },
    ],
  },
  {
    id: 'HLKB-0002',
    slug: 'deleted-variety-2003',
    title: '一档只播了七期就被下架的深夜节目，录像如今只剩三段',
    excerpt:
      '它没有预告，没有重播，下架时连一句说明都没有。二十年后，我们靠三段模糊录像和一份手写节目单，把它的结构重新拼了出来。',
    categoryId: 'deleted',
    categoryName: '被删档案',
    tags: ['被删档案', '电视考古', '录像带'],
    author: '灰盒档案员',
    date: '2025-07-02',
    readTime: 11,
    views: '41,220',
    heat: '极高',
    status: '已归档 · 存在缺页',
    cover:
      'https://readdy.ai/api/search-image?query=stack%20of%20dusty%20vhs%20tapes%20with%20handwritten%20labels%20on%20a%20dark%20shelf%2C%20an%20old%20tv%20showing%20static%20snow%2C%20warm%20amber%20light%20from%20a%20single%20lamp%2C%20melancholic%20archival%20atmosphere%2C%20brown%20gold%20tones&width=900&height=620&seq=hlkb-art-02&orientation=landscape',
    body: [
      {
        type: 'lead',
        text: '在档案圈里，我们把它叫作「七期节目」。它留下的痕迹少得可怜：三段总时长不到二十分钟的录像、一张手写节目单，以及当年观众在论坛里留下的几十条转述。',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'heading',
        text: '它为什么会被下架',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'paragraph',
        text: '答案已经无法确证。当年的播出方从未公开说明，论坛上流传的说法有四五种，彼此矛盾。我们能确认的只有一件事：节目在第七期播出后的第二天，原本排好的第八期时段被临时替换成了一部重播剧集。',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'list',
        text: '根据可考证的材料，这档节目的基本结构大致是这样的：',
        items: [
          '开场固定用同一段三秒音效，观众戏称「心跳」',
          '中段由一个不断更换座位的访谈环节组成，座位顺序被观众当作暗号解读',
          '结尾不道别，只在黑屏上打出一行随节目变化的短句',
          '全程没有主持人的正式自我介绍，这也让它很难被后来的检索系统抓到',
        ],
        image: '',
        caption: '',
      },
      {
        type: 'quote',
        text: '我们都以为它会一直播下去，所以没人认真录。等发现不对劲的时候，已经来不及了。',
        items: [],
        image: '',
        caption: '—— 论坛帖《还有人记得那个半夜的短句节目吗》，2005年',
      },
      {
        type: 'heading',
        text: '三段录像拼出的轮廓',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'paragraph',
        text: '三段录像分别来自不同的提供者，画质都不高，磁带边缘还有明显的信号干扰。把它们按时间码对齐之后，我们发现结尾那行短句其实存在一套隐藏的呼应关系：第三期的短句，在第六期里以另一种形式复现过一次。这未必是节目组的刻意设计，但至少说明它并非随手而写。',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'image',
        image:
          'https://readdy.ai/api/search-image?query=analog%20video%20editing%20desk%20with%20a%20handwritten%20program%20schedule%20sheet%2C%20film%20strips%20and%20notes%2C%20warm%20amber%20desk%20lamp%2C%20dark%20archival%20room%2C%20dusty%20investigative%20mood%2C%20brown%20and%20gold%20palette&width=1000&height=620&seq=hlkb-art-02-inline&orientation=landscape',
        caption: '档案员复原的手写节目单局部，第八期一栏被划掉后改写成了重播剧集。',
      },
      {
        type: 'note',
        text: '档案状态：本文材料完整度约 62%。第八期是否存在、下架的确切原因仍属未知，欢迎持有相关录像的网友联系档案室补充。',
        items: [],
        image: '',
        caption: '',
      },
    ],
  },
  {
    id: 'HLKB-0003',
    slug: 'glitch-art-circles',
    title: '在一个没人知道的免费图床里，他们用「损坏的图片」做了一批作品',
    excerpt:
      '上传失败留下的彩色条纹、被截断的像素块，在别人眼里是故障，在一小群创作者眼里是画笔。',
    categoryId: 'subculture',
    categoryName: '小众亚文化',
    tags: ['小众亚文化', '数字艺术', '故障美学'],
    author: '深水区',
    date: '2025-06-18',
    readTime: 8,
    views: '19,760',
    heat: '上升',
    status: '已归档 · 材料完整',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20glitch%20art%20with%20color%20bands%20and%20broken%20pixel%20blocks%20displayed%20on%20an%20old%20monitor%2C%20dark%20room%2C%20warm%20amber%20rim%20light%2C%20experimental%20digital%20art%20atmosphere%2C%20earthy%20brown%20and%20gold%20tones&width=900&height=620&seq=hlkb-art-03&orientation=landscape',
    body: [
      {
        type: 'lead',
        text: '故事的开头一点都不艺术：一个免费的图片外链服务出了故障，上传后经常显示成五颜六色的条纹。大多数人骂一句就换地方了，但有一小群人留了下来。',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'heading',
        text: '故障为什么好看',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'paragraph',
        text: '他们发现，只要控制上传文件的大小和格式，就能大致预判条纹出现的密度与颜色走向。这等于凭空得到了一支很难复制的笔。作品随后被贴在一本自制的电子刊物里，每期还附上参数说明，像一份公开的实验笔记。',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'list',
        text: '这场小规模实验留下的几种典型做法：',
        items: [
          '把同一张照片反复上传，取每次损坏后的不同结果并列成一组',
          '故意断开上传，捕捉中途被截断的色块',
          '用损坏图作为底纹，再叠上扫描出来的手写字',
          '在作品说明里只留参数，不解释含义，把解读权完全交给观看者',
        ],
        image: '',
        caption: '',
      },
      {
        type: 'quote',
        text: '我们不是在等它出错，我们是在练习怎么和意外合作。',
        items: [],
        image: '',
        caption: '—— 电子刊物《残影》创刊语，档案员译自原始文档',
      },
      {
        type: 'heading',
        text: '后来它去了哪儿',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'paragraph',
        text: '图床在几年后关停，刊物也随之停更。但参与者后来分散到了各种创作社区，把这种「与意外合作」的思路带了过去。今天我们在不少视觉作品里看到的刻意噪点与失真，追根溯源，多少能沾到这条线。',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'note',
        text: '档案状态：本文依据 6 期电子刊物原件与 2 位参与者的回忆整理，参数说明部分完整保留原始数据。',
        items: [],
        image: '',
        caption: '',
      },
    ],
  },
  {
    id: 'HLKB-0004',
    slug: 'forgotten-mmorpg-2001',
    title: '2001年那款只运营两年就停服的游戏，玩家至今仍在私服里重聚',
    excerpt:
      '它没有华丽的画面，只有一片像素森林和会掉线的服务器。停服二十多年后，一群中年人每个月还在同一个晚上上线。',
    categoryId: 'retro',
    categoryName: '尘封老游戏',
    tags: ['尘封老游戏', '私服', '像素'],
    author: '拾荒者阿九',
    date: '2025-05-30',
    readTime: 10,
    views: '33,540',
    heat: '极高',
    status: '已归档 · 材料完整',
    cover:
      'https://readdy.ai/api/search-image?query=nostalgic%20pixel%20art%20forest%20game%20scene%20on%20a%20retro%20crt%20monitor%2C%20old%20keyboard%20and%20mouse%20on%20a%20wooden%20desk%2C%20warm%20amber%20room%20light%2C%20cozy%20archival%20mood%2C%20brown%20gold%20tones&width=900&height=620&seq=hlkb-art-04&orientation=landscape',
    body: [
      {
        type: 'lead',
        text: '停服公告只有两行字。没有告别活动，也没有补偿方案。那天晚上，玩家们自发在游戏里最大的那棵树下列队，一直站到服务器被关闭。',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'heading',
        text: '一个只有森林的世界',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'paragraph',
        text: '游戏的地图很小，小到跑完全图用不了十分钟。但正因为小，玩家之间很难互不相识。谁在打哪只怪、谁在摆摊、谁又迷路卡在石头缝里，整个服务器都一清二楚。这种「被所有人看见」的感觉，是后来很多庞大世界也没能复刻的。',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'list',
        text: '老玩家们念念不忘的几个细节：',
        items: [
          '登录音乐只有六秒，循环时会有一段明显的卡顿，反而成了集体记忆',
          '掉线是常态，于是「等人上线」成了最早的社交礼仪',
          '交易全靠面对面，摆摊位置固定，久了自然形成一条商业街',
          '停服前最后一晚，官方未发通知，玩家却是自己凑齐的',
        ],
        image: '',
        caption: '',
      },
      {
        type: 'quote',
        text: '我们那会儿不是缺游戏玩，是缺一个每天固定能见到同一批人的地方。',
        items: [],
        image: '',
        caption: '—— 私服组织者，档案员访谈记录',
      },
      {
        type: 'heading',
        text: '他们是怎么把服务器重建起来的',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'paragraph',
        text: '重建工作的起点是一份当年泄露的客户端文件，加上几位玩家保存的地图截图。他们花了三年时间复原地形，又手写了整套服务端逻辑。如今每逢月初的周六，大家会约好上线，什么都不做，只是在树林里走一圈。',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'note',
        text: '档案状态：本文依据私服组织者提供的客户端文件、12 张历史截图与 3 段访谈整理。文中不涉及任何具体登录方式，仅作文化记录。',
        items: [],
        image: '',
        caption: '',
      },
    ],
  },
  {
    id: 'HLKB-0005',
    slug: 'vanished-portal-1999',
    title: '曾经首页广告排到第三屏的老门户，如今只剩下一张404',
    excerpt:
      '它一度是很多人打开浏览器后输入的第一个网址，后来栏目一个个消失，最后连首页都变成了空白页。',
    categoryId: 'vanished',
    categoryName: '消失的网站',
    tags: ['消失的网站', '门户', '网页存档'],
    author: '404猎人',
    date: '2025-05-11',
    readTime: 7,
    views: '22,180',
    heat: '上升',
    status: '已归档 · 存在缺页',
    cover:
      'https://readdy.ai/api/search-image?query=abandoned%20early%20web%20portal%20page%20screenshot%20pinned%20on%20a%20dark%20board%20connected%20by%20red%20string%2C%20warm%20directional%20lamp%20light%2C%20detective%20archive%20mood%2C%20amber%20and%20rust%20tones&width=900&height=620&seq=hlkb-art-05&orientation=landscape',
    body: [
      {
        type: 'lead',
        text: '要解释它当年有多重要，得先解释一个现在已经消失的习惯：在搜索引擎出现之前，人们是靠门户的栏目列表来「逛网」的。',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'heading',
        text: '首页就是一张地图',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'paragraph',
        text: '它的首页塞满了栏目入口，从新闻到星座、从聊天室到免费邮箱，密密麻麻排到第三屏才见底。加载速度很慢，但没人抱怨，因为那几乎是当时唯一的选择。研究者后来把它称作「人肉导航时代」。',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'list',
        text: '从网页存档中还原出的栏目结构：',
        items: [
          '顶部是不断滚动的公告条，字体会随活动变化颜色',
          '中段按主题分列，同一栏目常在一屏内重复出现两次',
          '底部是那时盛行的交换链接区，图标风格五花八门',
          '免费邮箱是它留住用户的关键，注册量一度占据全部流量的大半',
        ],
        image: '',
        caption: '',
      },
      {
        type: 'quote',
        text: '那会儿上网没有「搜索」这个概念，你得先知道去哪，而它就是那个「去哪」。',
        items: [],
        image: '',
        caption: '—— 网页存档说明文档，档案员整理',
      },
      {
        type: 'heading',
        text: '它是怎么一点点消失的',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'paragraph',
        text: '先是免费邮箱停止新用户注册，接着聊天室入口被折叠进二级页面，再后来首页改版成一屏的简洁样式，最后在某一年，整个域名返回了404。整个过程没有公告，只有一次次不起眼的改版。消失不是一瞬间的事，它是慢慢变薄的。',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'note',
        text: '档案状态：本文依据 8 个年份的网页存档快照复原，2003至2006年的首页快照缺失，栏目结构以文字描述补全。',
        items: [],
        image: '',
        caption: '',
      },
    ],
  },
  {
    id: 'HLKB-0006',
    slug: 'meme-origin-2008',
    title: '一句被用烂十几年的梗，最早其实来自一条被删的弹幕',
    excerpt:
      '所有人都在用，却没人说得清它从哪来。我们沿着最早的几处出现记录往回追，发现源头比想象中安静得多。',
    categoryId: 'meme',
    categoryName: '迷因考古',
    tags: ['迷因考古', '弹幕', '溯源'],
    author: '老磁带',
    date: '2025-04-22',
    readTime: 6,
    views: '57,930',
    heat: '极高',
    status: '已归档 · 存在争议',
    cover:
      'https://readdy.ai/api/search-image?query=layered%20timestamped%20screenshots%20and%20video%20frames%20overlapping%20on%20a%20dark%20surface%2C%20glowing%20screen%20reflections%2C%20warm%20amber%20accent%20light%2C%20gritty%20texture%2C%20earthy%20brown%20palette%2C%20research%20collage&width=900&height=620&seq=hlkb-art-06&orientation=landscape',
    body: [
      {
        type: 'lead',
        text: '一个梗被用得太广之后，它的出处反而变得不重要了。但我们还是想弄清楚：第一次，到底是谁说的。',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'heading',
        text: '往前追，能追到哪一年',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'paragraph',
        text: '检索可考的公开文本，最早的完整出现记录集中在同一年，比大众印象中的时间还要早两三年。那几年它只在一个很小的论坛板块里流通，语境也和今天完全不同，带着一点自嘲的味道，而不是现在的夸张。',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'list',
        text: '溯源过程中发现的几个关键节点：',
        items: [
          '最早一批记录几乎都出现在同一类视频的弹幕里，且用词略有出入',
          '有一条早期弹幕被作者本人删除，只剩下他人转述的截图',
          '真正让它扩散的是一次跨平台的搬运，搬运者顺手改了后半句',
          '语感的变化发生在扩散之后，而不是源头',
        ],
        image: '',
        caption: '',
      },
      {
        type: 'quote',
        text: '源头被删掉这件事本身就很说明问题：它最初并不是一句口号，只是一句随口的话。',
        items: [],
        image: '',
        caption: '—— 档案员溯源笔记',
      },
      {
        type: 'heading',
        text: '为什么我们不敢下定论',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'paragraph',
        text: '弹幕本身极易被清理，早期的平台存档也不完整。我们能确认的是「最早可见」，却无法确认「最早存在」。因此本文把结论标为存疑，并欢迎任何持有更早记录的网友补充。',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'note',
        text: '档案状态：本文为存疑条目，结论标注为「最早可见记录」。凡涉及具体平台与用户的内容，均按公开讨论范围呈现，不做个人指向。',
        items: [],
        image: '',
        caption: '',
      },
    ],
  },
  {
    id: 'HLKB-0007',
    slug: 'dialup-zine',
    title: '拨号时代的电子刊物：他们在软盘里传阅了一百期',
    excerpt:
      '没有印刷厂，没有刊号，一本用软盘传阅的刊物，却认真做满了一百期，连每期的更正都写得一丝不苟。',
    categoryId: 'forum',
    categoryName: '早期论坛',
    tags: ['早期论坛', '电子刊物', '软盘'],
    author: '灰盒档案员',
    date: '2025-04-03',
    readTime: 8,
    views: '15,240',
    heat: '平稳',
    status: '已归档 · 材料完整',
    cover:
      'https://readdy.ai/api/search-image?query=collection%20of%20floppy%20disks%20and%20hand%20assembled%20printed%20zines%20with%20rubber%20stamps%20on%20a%20dark%20wooden%20desk%2C%20warm%20amber%20desk%20lamp%20light%2C%20dusty%20nostalgic%20mood%2C%20brown%20and%20gold%20tones&width=900&height=620&seq=hlkb-art-07&orientation=landscape',
    body: [
      {
        type: 'lead',
        text: '它的发行方式在今天看来近乎浪漫：作者把文件拷进软盘，用挂号信寄给读者，读者再拷给别人。就这样，一本刊物走完了整整一百期。',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'heading',
        text: '一本用爱发电的刊物长什么样',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'paragraph',
        text: '每期页数不多，但结构固定：卷首语、两到三篇长文、一个读者来信栏目，最后是更正与下期预告。排版全靠手工调整，图片很少，字号也偏小，因为那个年代的文件大小是硬约束。',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'list',
        text: '让档案员印象最深的几个坚持：',
        items: [
          '每期都留出固定位置刊登更正，哪怕只是错别字也照登不误',
          '稿件被采用不付稿费，只寄一张手写感谢卡',
          '读者来信栏目从不删改内容，只在文末加编者按',
          '停刊那一期没有悲情告别，只写了一句「磁盘快满了，先存着」',
        ],
        image: '',
        caption: '',
      },
      {
        type: 'quote',
        text: '我们没想过要影响谁，只是觉得每周攒点东西出来，日子就没那么长。',
        items: [],
        image: '',
        caption: '—— 刊物主办者回忆，档案员访谈记录',
      },
      {
        type: 'heading',
        text: '一百期之后',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'paragraph',
        text: '停刊后，部分作者转向了论坛与博客，把那种固定的栏目结构也带了过去。今天很多长文作者仍习惯在文末写「更正」，追根溯源，这份习惯或许比我们以为的更老。',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'note',
        text: '档案状态：本文依据完整的一百期刊物电子件与 2 张手写感谢卡原件整理，内容完整度约 95%。',
        items: [],
        image: '',
        caption: '',
      },
    ],
  },
  {
    id: 'HLKB-0008',
    slug: 'deleted-wiki',
    title: '一个被整体删除的百科条目，靠网友的两百张截图活了下来',
    excerpt:
      '删除发生时，条目已经积累了三年内容。如今我们手中的版本，是一群素不相识的人用截图一页页拼回的记忆。',
    categoryId: 'deleted',
    categoryName: '被删档案',
    tags: ['被删档案', '百科', '众包存档'],
    author: '404猎人',
    date: '2025-03-19',
    readTime: 9,
    views: '36,870',
    heat: '极高',
    status: '已归档 · 众包复原',
    cover:
      'https://readdy.ai/api/search-image?query=dozens%20of%20overlapping%20webpage%20screenshots%20spread%20across%20a%20large%20dark%20table%20being%20reassembled%2C%20magnifying%20glass%20and%20notes%2C%20warm%20amber%20lamp%20light%2C%20archival%20restoration%20mood%2C%20brown%20gold%20tones&width=900&height=620&seq=hlkb-art-08&orientation=landscape',
    body: [
      {
        type: 'lead',
        text: '删除来得毫无预兆。前一天还能正常访问的条目，第二天变成了空白提示。最先反应过来的不是档案馆，而是一群平时只是默默阅读的普通网友。',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'heading',
        text: '两百张截图是怎么凑起来的',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'paragraph',
        text: '有人翻出了自己几个月前为了写论文存下的整页截图，有人找到了浏览器缓存里的离线副本，还有人只是恰好开着那个页面没有关。这些材料被集中到一个共享目录里，编号、对齐、去重，前后花了将近一年。',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'list',
        text: '复原工作中最棘手的几处：',
        items: [
          '不同截图的分辨率差异极大，文字需要逐行人工转录',
          '引用脚注大量失效，只能反查被引用的原始出处',
          '部分段落存在多个历史版本，需要按编辑时间排序',
          '图片类资料几乎全部丢失，仅能依据图注还原描述',
        ],
        image: '',
        caption: '',
      },
      {
        type: 'quote',
        text: '没有谁是负责人。大家只是在同一个目录里，各自补自己手上的那一块。',
        items: [],
        image: '',
        caption: '—— 参与复原的网友，档案员访谈记录',
      },
      {
        type: 'heading',
        text: '这件事的意义',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'paragraph',
        text: '复原版本未必和原始条目一字不差，但它证明了一件事：只要有人愿意存一份，内容就不会真的消失。这也是我们做这个档案馆最想留下的东西——不是某一条具体的记录，而是「保存」这个动作本身。',
        items: [],
        image: '',
        caption: '',
      },
      {
        type: 'note',
        text: '档案状态：本文为众包复原条目，正文已标注转录偏差范围。原始条目名与相关主体信息按公开讨论范围处理，不做个人指向。',
        items: [],
        image: '',
        caption: '',
      },
    ],
  },
];